import api from "./axios";

export const stripeConnectApi = {
  createAccount: async () => {
    const response = await api.post("/provider/stripe/connect-account");
    return response.data;
  },

  createAccountSession: async () => {
    const response = await api.post("/provider/stripe/account-session");
    return response.data;
  },

  getAccountStatus: async () => {
    const response = await api.get("/provider/stripe/connect-account-status");
    return response.data;
  },

  expressDashboard: async () => {
    const response = await api.get("/provider/stripe/express-dashboard");
    return response.data;
  },


  bankPayouts: async () => {
    const response = await api.get("/provider/stripe/bank-payouts");
    return response.data;
  },

  balance: async () => {
    const response = await api.get("/provider/stripe/balance");
    return response.data;
  },

  requestPayout: async (amount) => {
    const response = await api.post("/provider/stripe/request-payout", amount != null ? { amount } : {});
    return response.data;
  },
};
